import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { Button } from "./ui/button";

export function Header() {
  const { t } = useLanguage();
  const { user } = useAuth();
  const navigate = useNavigate();

  const links = [
    { href: "#mission", label: t("nav.mission") },
    { href: "#principle", label: t("nav.model") },
    { href: "#method", label: t("nav.method") },
    { href: "#roles", label: t("nav.roles") },
  ];

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md bg-[#FBFBF9]/85 border-b border-[#1A1F1C]/8"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="brand-home-link">
          <span className="h-7 w-7 rounded-lg bg-[#1E3A2B] flex items-center justify-center">
            <span className="h-2.5 w-2.5 rounded-full bg-[#C27B2B]" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-sm text-[#1A1F1C]">Reach New Edge™</span>
            <span className="font-mono-label text-[9px] text-[#5B655F] mt-0.5">Powered by Learning Recovery OS™</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-[#525B56] hover:text-[#1A1F1C] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          {user ? (
            <Button
              onClick={() => navigate("/dashboard")}
              data-testid="nav-dashboard-button"
              className="rounded-full bg-[#1E3A2B] hover:bg-[#14281E] text-[#FBFBF9]"
            >
              {t("nav.dashboard")}
            </Button>
          ) : (
            <Button
              onClick={() => navigate("/login")}
              data-testid="nav-login-button"
              className="rounded-full bg-[#1E3A2B] hover:bg-[#14281E] text-[#FBFBF9]"
            >
              {t("nav.login")}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
